import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-pictures1-icon',
  templateUrl: './files-pictures1.component.html'
})
export class FilesPictures1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
